export default function(instance) {
  return {
    //Requests
    getRequests(data) {
      return instance.get("/api/services/applications/admin/", {
        params: data ? data : ""
      });
    },
    createRequest(data) {
      return instance.post("/api/services/applications/admin/", {
        full_name: data.full_name,
        phone: data.phone,
        address: data.address,
        services: data.services,
        date_recommend: data.date_recommend,
        user: data.user
      });
    },
    getRequest(idRequest) {
      return instance.get(`/api/services/applications/admin/${idRequest}/`);
    },
    deleteRequest(idRequest) {
      return instance.delete(`/api/services/applications/admin/${idRequest}/`);
    },

    updateStatusRequest(idRequest, data) {
      return instance.put(`/api/services/applications/admin/${idRequest}/`, {
        status: data.status
      });
    },

    updateVisibleRequest(idRequest, data) {
      return instance.put(`/api/services/applications/admin/${idRequest}/`, {
        is_hidden: data.is_hidden
      });
    },

    updatePriceRequest(idRequest, data) {
      return instance.put(`/api/services/applications/admin/${idRequest}/`, {
        price: data.price
      });
    },

    sendMessage(data) {
      return instance.post("/api/services/applications/messages/admin/", {
        from_user: data.from_user,
        text: data.text,
        chat: data.chat
      });
    },
    deleteMessage(idMessage) {
      return instance.delete(
        `/api/services/applications/messages/admin/${idMessage}`
      );
    },
    //END Requests

    //Categories
    getCategories(data) {
      return instance.get("/api/services/admin/", {
        params: data ? data : ""
      });
    },
    createCategory(data) {
      return instance.post("/api/services/admin/", { name: data.name });
    },
    getCategory(idCategory) {
      return instance.get(`/api/services/admin/${idCategory}/`);
    },
    deleteCategory(idCategory) {
      return instance.delete(`/api/services/admin/${idCategory}/`);
    },
    updateCategory(idCategory, data) {
      return instance.put(`/api/services/admin/${idCategory}/`, {
        name: data.name,
        is_closed: data.is_closed
      });
    },
    updateServicesImage(idCategory, data) {
      let formData = new FormData();
      formData.append("image", data.imageFile);

      return instance.put(`/api/services/admin/${idCategory}/`, formData, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      });
    }
    //END Categories
  };
}
